import { Controller } from 'react-hook-form';
import { Box, VStack } from 'native-base';
import { useTranslation } from 'react-i18next';

import { ButtonGroup, Text } from '@pimm/base';
import { useFormSiteGoals } from '../hooks';
import { FormSiteGoals } from './form-site-goals';

type SettingsStoreGoalsProps = {
  form: ReturnType<typeof useFormSiteGoals>;
};

export const SettingsStoreGoals = ({ form }: SettingsStoreGoalsProps) => {
  const { t } = useTranslation();
  return (
    <VStack>
      <VStack
        position="sticky"
        top={0}
        justifyContent="center"
        pt={2}
        pb={3}
        px={4}
        minH="58px"
        borderBottomWidth={1}
        zIndex={1}
        bg="white"
      >
        <Text size="xl" fontWeight={700} color="gray.900">
          {t('sos:store_goals')}
        </Text>
        <Text size="md" fontWeight={500} color="gray.900" lineHeight="xs">
          {t('sos:store_goals_note')}
        </Text>
      </VStack>

      {/* Days of the week */}
      <VStack space={3} px={4} py={3} borderBottomWidth={1}>
        <Text size="xl" fontWeight={700} color="gray.900" lineHeight="xs">
          {t('sos:days_of_the_week')}
        </Text>

        <Controller
          name="isSevenDays"
          control={form.control}
          render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => {
            return (
              <ButtonGroup value={value} onChange={onChange} w="full" minH="68px">
                {[
                  {
                    title: t('sos:seven_day_goal'),
                    caption: t('sos:seven_day_goal_note'),
                    value: true,
                  },
                  {
                    title: t('sos:weekday_weekend'),
                    caption: t('sos:weekday_weekend_note'),
                    value: false,
                  },
                ].map(tab => (
                  <ButtonGroup.Item key={tab.title} value={tab.value} flex={1} justifyContent="flex-start" h="container">
                    {/* prettier-ignore */}
                    <Box w="full" px={2} overflow="hidden" maxW={{ base: 300, xl: 300 }}>
                      <Text size="md" fontWeight={700} color="gray.900">
                        {tab.title}
                      </Text>
                      <Text fontWeight={500} color="gray.900" numberOfLines={2} lineHeight="xs" adjustsFontSizeToFit>
                        {tab.caption}
                      </Text>
                    </Box>
                  </ButtonGroup.Item>
                ))}
              </ButtonGroup>
            );
          }}
        />
      </VStack>

      <Box px={4}>
        <FormSiteGoals form={form} />
      </Box>
    </VStack>
  );
};
